"use client";

import { useRouter } from "@packages/i18n";
import { useSession } from "@packages/sdk";
import { useIsDesktopViewport } from "@packages/ui";
import { useEffect } from "react";

export const MobileRedirect = () => {
  const isDesktop = useIsDesktopViewport();
  const router = useRouter();
  const { status } = useSession();

  useEffect(() => {
    if (isDesktop && status !== "loading") {
      if (status === "authenticated")
        router.replace("/settings/account/profile");
      else router.replace("/settings/language");
    }
  }, [isDesktop, status]);

  return <></>;
};
